import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {ChucVu} from '../../models/danhmuc/chucvu';
import {Users} from '../../models/staff/users';
import {SessionToken} from '../../models/staff/sessiontoken';
import {Sessioncommand} from '../../global/sessioncommand';

const apiUrl = `${environment.apiUrl}/api`;

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(public httpService: HttpClient) { }

  public getToken(params: Object): Observable<SessionToken>
  {
    return  this.httpService.post(`${apiUrl}/login`, params).pipe(
      map(data => {
       let sessionToken: SessionToken = new SessionToken().deserialize(data);
        sessionStorage.setItem('userId', sessionToken.userId.toString());
        sessionStorage.setItem('token', sessionToken.token);
        sessionStorage.setItem('staffId', sessionToken.staffId.toString());
        sessionStorage.setItem('maDonVi', sessionToken.maDonVi.toString());

        return  sessionToken;
      })
    );
  }
  isUserLoggedIn() {

    let user = sessionStorage.getItem('userId');
    let staffId = sessionStorage.getItem('staffId');
    let maDonVi = sessionStorage.getItem('maDonVi');
    return !(user === null || user ==='null') && !(staffId === null || staffId === 'null') && !(maDonVi === null || maDonVi==='null');
  }

}
